/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import CurrentRetailerRentalPlanCard from './index/current-rental-plan-card';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import Notice from 'components/notice';

// new
import AnnotatedSection from 'components/annotated-section';
import ScheduledChangesNotice from 'modules/me/rental/scheduled-changes-notice';

/**
 * Style dependencies
 */
import './styles.scss';

const Rental = (props) => {

    return (
        <Box>
            <DocumentHead title='Billing - Manage Rental Plan - Tower Systems' />
            <Topbar title='Rental Plan' subTitle='Manage your rental plan' selected='rental'>

            </Topbar>

            <ScheduledChangesNotice />
            <Main padding='xxlarge'>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Subscription Details'
                            description='Your current rental plan details.'
                        />
                        <AnnotatedSection.Content>
                            <CurrentRetailerRentalPlanCard />
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect()(Rental);
